import { InfoTip } from '../ui/info-tip';
import { ExplanationContent } from '../ui/explanation-content';
import { drrHint, type DrrExplanation } from './drr-explanation';

const fmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 });
const finite = (n: unknown): n is number => typeof n === 'number' && Number.isFinite(n);

export function DrrExplanationContent({ value, hint }: { value: DrrExplanation; hint?: string }) {
  const adjusted = value.drrBasis === 'cabinet' || value.drrBasis === 'product';
  const rows: Array<{ label: string; value: string }> = [];
  const reserved = adjusted && value.buyoutPolicy === 'returns-reserve';
  if (reserved && finite(value.buyoutNetRate)) rows.push({ label: 'После возвратов · 30 дней', value: `${fmt.format(value.buyoutNetRate * 100)} %` });
  if (reserved && finite(value.buyoutReserveRate)) rows.push({ label: 'Дополнительный запас', value: `${fmt.format(value.buyoutReserveRate * 100)} п.п.` });
  if (adjusted && finite(value.buyoutRate)) rows.push({ label: reserved ? 'Расчётный выкуп' : `Выкуп ${value.drrBasis === 'product' ? 'товара' : 'кабинета'} · ${value.buyoutWindowDays || 30} дней`, value: `${fmt.format(value.buyoutRate * 100)} %` });
  if (adjusted && finite(value.revenueBuyout)) rows.push({ label: reserved ? 'Выручка для расчёта' : 'Выручка после выкупа', value: `${fmt.format(value.revenueBuyout)} ₽` });
  if (adjusted && finite(value.drrOrders)) rows.push({ label: 'Без поправки на выкуп', value: `${fmt.format(value.drrOrders)} %` });
  const noRevenue = (adjusted ? value.revenueBuyout : value.revenue) === 0 && (value.spend ?? 0) > 0;
  return <ExplanationContent
    summary={reserved ? 'ДРР с дополнительным запасом на возвраты.' : adjusted ? 'Доля рекламы в выручке с поправкой на выкуп.' : 'Доля рекламы в выручке заказов, без поправки на выкуп.'}
    rows={rows}
    warning={noRevenue ? (reserved ? 'Расчётная выручка с запасом — 0 ₽; ДРР ∞.' : 'Расход есть, выручки нет — ДРР ∞.') : value.drrBasis === 'orders' ? 'Нет корректной доли выкупа кабинета за 30 дней.' : undefined}
    details={<>{drrHint(value)}{hint && <p className="rk-explanation-context">{hint}</p>}</>}
    note={reserved ? 'Консервативная оценка, не фактический выкуп.' : adjusted ? 'Оценка, не фактический выкуп кампании.' : undefined}
  />;
}

/** Overview receives its exact calculation text from the API; do not reinterpret its basis. */
export function DrrOverviewTip({ hint }: { hint?: string }) {
  return <InfoTip label="Как считается ДРР" title="ДРР кабинета"><ExplanationContent
    summary="Доля рекламных расходов в выручке кампаний."
    details={hint || 'Основание расчёта пока не получено.'}
    note="Цвет — по целевому ДРР кабинета."
  /></InfoTip>;
}
